// Razorpay Standard Checkout helper. The SDK script is loaded lazily on first
// checkout invocation — saves ~90 KB on initial page load.

const RAZORPAY_KEY_ID = process.env.REACT_APP_RAZORPAY_KEY_ID;
const SCRIPT_SRC = "https://checkout.razorpay.com/v1/checkout.js";

const loadRazorpay = () =>
  new Promise((resolve, reject) => {
    if (window.Razorpay) return resolve();
    const existing = document.querySelector(`script[src="${SCRIPT_SRC}"]`);
    if (existing) {
      existing.addEventListener("load", () => resolve());
      existing.addEventListener("error", () => reject(new Error("Razorpay SDK failed to load")));
      return;
    }
    const s = document.createElement("script");
    s.src = SCRIPT_SRC;
    s.async = true;
    s.onload = () => resolve();
    s.onerror = () => reject(new Error("Razorpay SDK failed to load"));
    document.head.appendChild(s);
  });

// Fire-and-forget warm-up. Call as soon as you know the user might pay
// (e.g., paywall dialog opens) so the SDK is ready before they click Pay.
export const preloadRazorpay = () => {
  loadRazorpay().catch(() => {});
};

export const openRazorpayCheckout = async ({
  orderId,
  amount,
  currency = "INR",
  email,
  name = "Byo Cha Khape",
  description = "Sindhi film access",
  themeColor = "#D4A373",
}) => {
  await loadRazorpay();

  return new Promise((resolve, reject) => {
    const rzp = new window.Razorpay({
      key: RAZORPAY_KEY_ID,
      amount,
      currency,
      order_id: orderId,
      name,
      description,
      prefill: { email },
      notes: { email },
      theme: { color: themeColor },
      modal: {
        ondismiss: () => reject(new Error("dismissed")),
        confirm_close: false,
        escape: true,
      },
      handler: (response) => {
        resolve({
          razorpay_order_id: response.razorpay_order_id,
          razorpay_payment_id: response.razorpay_payment_id,
          razorpay_signature: response.razorpay_signature,
        });
      },
    });

    rzp.on("payment.failed", (resp) => {
      reject(new Error(resp?.error?.description || "Payment failed"));
    });

    rzp.open();
  });
};
